import KumosearchError from "./KumosearchError";

export default class ObjectUnprocessable extends KumosearchError {}
